<template>
  <section v-if="getRealtimeCallsinQueue">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="card green">
            <div class="card-content">
              <div class="icon">
                <img src="/imgs/icons/happy_realtime.png" alt="Completadas">
              </div>
              <div class="details">
                <h3>Completadas</h3>
                <h1>{{ totalCalls.operator }}</h1>
                <p>Chamadas Finalizadas</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card orange">
            <div class="card-content">
              <div class="icon">
                <img src="/imgs/icons/clock_realtime.png" alt="Em Espera">
              </div>
              <div class="details">
                <h3>Em Espera</h3>
                <h1>{{ totalCalls.waiting }}</h1>
                <p>Chamadas em Espera</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card blue">
            <div class="card-content">
              <div class="icon">
                <img src="/imgs/icons/phone_realtime.png" alt="Ativas">
              </div>
              <div class="details">
                <h3>Ativas</h3>
                <h1>{{ totalCalls.active }}</h1>
                <p>Chamadas Ativas</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card red">
            <div class="card-content">
              <div class="icon">
                <img src="/imgs/icons/sad_realtime.png" alt="Abandonadas">
              </div>
              <div class="details">
                <h3>Abandonadas</h3>
                <h1>{{ totalCalls.abandon }}</h1>
                <p>Ligações Abandonadas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";
import io from 'socket.io-client';
import { getStatus } from "../realtime/status.js";
import totalCallsDashboard from '../realtime/TotalCallsDashboard.vue';
import cardRealtimeDashboard from '../realtime/CardRealtimeDashboard.vue';

export default {
  components: { totalCallsDashboard, cardRealtimeDashboard },
  data() {
    return {
      connection: null,
      userQueues: [],
      obj: [],
      operators: [],
      queueSelect: '*',
      apiCalls: {}
    };
  },
  methods: {
    totalWait(data) {
      this.wait = data;
      console.log("DADOS ENVIADOS DO TOTAL CALLS: ",this.wait);
    },
    setupSocketConnection() {
        const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
        if (parsedTelefone) {
          this.connection = io(`${location.protocol}//${location.hostname}:${process.env.MIX_OPERATOR_REALTIME_PORT}`, {
          query: {
            source: "CardStatusToOperador",
            exten: user.getExtension()
          },
          reconnection: true,
          reconnectionAttempts: Infinity,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          randomizationFactor: 0.5,
          pingTimeout: 300000, // 5 minutos
          pingInterval: 60000  // 1 minuto
        });
            
        this.connection.on('connect', () => {
          console.info('Conectado ao serviço Realtime Operator');
          this.listenCallsUpdate();
        });
            
        this.connection.on('disconnect', (reason) => {
          console.info(`Desconectado: ${reason}`);
        });
            
        this.connection.on('reconnect_attempt', (attemptNumber) => {
          console.info(`Tentativa de reconexão #${attemptNumber}`);
        });
      } else {
          this.connection = {
            on: function() {},
            emit: function() {}
          };
      }
    },
    fetchRealtimeData() {
      axios.get(`${location.protocol}//${location.hostname}:${process.env.MIX_OPERATOR_REALTIME_PORT}/api/get-all-calls`)
        .then(({data}) => {
          this.processAPICalls(data);
        })
        .catch(error => {
          console.error('Error fetching realtime data:', error);
        });
    },
    processAPICalls(data){
      const totalObj = {
        waiting: [],
        active: [],
        abandon: [],
        operator: [],
        queue: [],
      }
      if(Object.keys(data).length){
        Object.entries(data).map(el => {
          if(el[1].callsCount?.length){
            el[1].callsCount.map(count => {
              if(count.key === user.getExtension() || this.userQueues.some(el => el.name === count.key)){
                totalObj[el[0]].push({key: count.key, value: count.value})
              }
            })
          }
        })
      }
      this.apiCalls = totalObj
    },
    listenCallsUpdate(){
      this.connection.on('value-updated', (data) => {
        this.processCallsUpdate(data)
      })
    },
    processCallsUpdate(data){
      if(Object.keys(this.apiCalls).length){
        Object.entries(this.apiCalls).map(el => {
          const type = el[0]
          const callsCount = el[1]
          if(callsCount.length){
            callsCount.map(count => {
              if(count.key === data.key && type === data.type){
                count.value = data.value
              }
            })
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters(["getRealtimeCallsinQueue"]),
    filteredOperators() {
      if (this.queueSelect != '*') {
        return this.operators.filter(el => {
          return el.queues.some(queue => {
            return queue.name.includes(this.queueSelect);
          });
        });
      } else {
        return this.operators;
      }
    },
    totalCalls(){
      const obj = {
        waiting: 0,
        abandon: 0,
        active: 0,
        operator: 0
      }
      
      if(Object.keys(this.apiCalls).length){
        Object.entries(this.apiCalls).map(el => {
          const type = el[0]
          const countArray = el[1]
          if(countArray.length){
            countArray.map(count => {
              obj[type] += count.value
            })
          }
        })
      }

      return obj
    }
  },
  async created() {
    axios.get('/realtime/listUsersPhone').then(({ data }) => {
      this.operators = data;
    });
    this.userStatus = 'Deslogado';

    this.setupSocketConnection();
    this.active = getStatus().ligacao;
    
    await axios.get('/user-queues').then(({ data }) => {
      if (data.length > 0) {
        this.userQueues = data;
      }
    });
    this.fetchRealtimeData();
  },
  mounted() {
    setInterval(() => {
      setTimeout(async () => {
        this.connection = {
            on: function() {},
            emit: function() {}
        };
        this.setupSocketConnection();
        this.fetchRealtimeData();
      }, 1000)
    }, 300000); //5 MINUTOS
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 80px;
}
.row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.col {
  flex: 1;
  max-width: 25%;
  padding: 10px;
}
.card {
  border-radius: 6px;
  color: white;
  height: 20em;
  text-align: center;
  padding: 3em;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
}
.green {
  background-color: #16a085;
}
.orange {
  background-color: #f39c12;
}
.blue {
  background-color: #17a2b8;
}
.red {
  background-color: #c0392b;
}
.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.icon img {
  margin-bottom: 5px;
  width: 50px;
  height: 50px;
}
.details h3 {
  margin-top: 5px;
  font-size: 1.5em;
}
.details h1 {
  margin-top: 5px;
  font-size: 3em;
}
.details p {
  margin-top: 5px;
  color: black;
}

</style>
